function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.656 11.18a.844.844 0 01.014 1.687H2.344a.844.844 0 01-.014-1.687h19.326z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.023 1.5c.462 0 .836.37.844.83v19.326a.844.844 0 01-1.687.014V2.344c0-.466.377-.844.843-.844z"
}));

var SvgIconAdd = function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconAdd;